// extracted by mini-css-extract-plugin
export default {"box":"AccessDeniedPage_box__VRCOA","card":"AccessDeniedPage_card__ogtmq","card-header":"AccessDeniedPage_card-header__TAIOc"};